"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.submitterManagerFactory = void 0;
var syncTaskComposite_1 = require("../syncTaskComposite");
var eventsSubmitter_1 = require("./eventsSubmitter");
var impressionsSubmitter_1 = require("./impressionsSubmitter");
var impressionCountsSubmitter_1 = require("./impressionCountsSubmitter");
var telemetrySubmitter_1 = require("./telemetrySubmitter");
function submitterManagerFactory(params) {
    var submitters = [
        (0, impressionsSubmitter_1.impressionsSubmitterFactory)(params),
        (0, eventsSubmitter_1.eventsSubmitterFactory)(params)
    ];
    var impressionCountsSubmitter = (0, impressionCountsSubmitter_1.impressionCountsSubmitterFactory)(params);
    if (impressionCountsSubmitter)
        submitters.push(impressionCountsSubmitter);
    var telemetrySubmitter = (0, telemetrySubmitter_1.telemetrySubmitterFactory)(params);
    if (telemetrySubmitter)
        submitters.push(telemetrySubmitter);
    return (0, syncTaskComposite_1.syncTaskComposite)(submitters);
}
exports.submitterManagerFactory = submitterManagerFactory;
